exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Filter__filter___1NzOQ{width:100%;max-width:350px;font-size:.9em;border:none;background-color:#eff0f4;outline:none;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;padding:1em;border-radius:.3rem}@media (max-width:800px){.Filter__filter___1NzOQ{font-size:.8em;max-width:270px}}", ""]);

// exports
exports.locals = {
	"filter": "Filter__filter___1NzOQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"sourceMap":true,"plugins":[null]}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/Filter.less
// module id = ./node_modules/css-loader/index.js?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":true,"plugins":[null]}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/Filter.less
// module chunks = 0